export const FRANCHISE_API_PATH = 'Franchise';

export const FRANCHISES_METADATA_REQUESTED = 'franchises/METADATA_REQUESTED';
export const FRANCHISES_METADATA_SUCCESS = 'franchises/METADATA_SUCCESS';
export const FRANCHISES_METADATA_FAILURE = 'franchises/METADATA_FAILURE';

export const FRANCHISES_LIST_DATA_REQUESTED = 'franchises/LIST_REQUESTED';
export const FRANCHISES_LIST_DATA_SUCCESS = 'franchises/LIST_SUCCESS';
export const FRANCHISES_LIST_DATA_FAILURE = 'franchises/LIST_FAILURE';

export const FRANCHISES_CREATE_REQUESTED = 'franchises/CREATE_REQUESTED';
export const FRANCHISES_CREATE_SUCCESS = 'franchises/CREATE_SUCCESS';
export const FRANCHISES_CREATE_FAILURE = 'franchises/CREATE_FAILURE';

export const FRANCHISES_UPDATE_REQUESTED = 'franchises/UPDATE_REQUESTED';
export const FRANCHISES_UPDATE_SUCCESS = 'franchises/UPDATE_SUCCESS';
export const FRANCHISES_UPDATE_FAILURE = 'franchises/UPDATE_FAILURE';

export const FRANCHISES_GET_REQUESTED = 'franchises/GET_REQUESTED';
export const FRANCHISES_GET_SUCCESS = 'franchises/GET_SUCCESS';
export const FRANCHISES_GET_FAILURE = 'franchises/GET_FAILURE';

export const FRANCHISES_MESSAGE_CLEAR = 'franchises/MESSAGE_CLEAR';
